import 'ui-theme/js/components/slide';
var slide = UX.slide;

slide.vPort = 'screen-sm';
